var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPdppreviewPlayIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "pdppreview-play-icon_svg__product-thumbnail__video-icon",
  viewBox: "0 0 40 40"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  opacity: 0.7
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 9v23l20-10Z",
  className: "pdppreview-play-icon_svg__icon-play"
})));
export { SvgPdppreviewPlayIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/pdppreview-play-icon.286d728e.svg";